import { api } from "..";

interface RestoreCouponsPayload {
  couponIds: string[];
}

export const restoreCoupons = async ({
  couponIds,
}: RestoreCouponsPayload): Promise<{ success: boolean }> => {
  const res = await api.client.post(
    `/users-new/coupons/bulk-restore`,
    { couponIds }
  );
  return res.data;
};
